/**
 * GutenDevTheme scripts (footer)
 * This file contains any js scripts you want added to the theme's footer. 
 */

// START CUSTOM JS ---------------------------------------

// load the script...
import Headroom from "headroom.js";
// grab element for Headroom
var headroomElement = document.querySelector("#c-nav-wrapper");

// get height of element for Headroom
// var headerHeight = headroomElement.offsetHeight; 

// construct an instance of Headroom, passing the element
var headroom = new Headroom(headroomElement, {
  "offset": 165,
  "tolerance": 1,
  // "classes": {
  //   "initial": "animate__animated",
  //   "pinned": "animate__slideInDown",
  //   "unpinned": "animate__slideOutUp"
  // }
});
headroom.init();

// END CUSTOM JS ---------------------------------


// START CUSTOM JQUERY DOC READY ---------------------------------

jQuery( document ).ready(function( $ ) {

  // modal menu init
  var modal_menu = $("#c-modal-nav-button").totalModal({
    modalTarget: '#modal-navigation',
    modalClose: '#close-total-modal',
    animatedIn: 'animate__slideInDown',
    animatedOut: 'animate__slideOutUp',
    animationDuration: '444ms',
    color: '#007078',
    afterOpen : function() {
      document.getElementById('modal-navigation').focus();
    },
    afterClose: function() {
      $( '#modal-navigation' ).addClass( 'is-hidden' )
      $( 'body, html' ).css({ 'overflow': '' });
    }
  });

  // modalExtras() - just some stuff to make the modal menu better
  function modalExtras() {
    // get last and current hash + update on hash change
    var currentHash = function() {
      return location.hash.replace(/^#/, '')
    }
    var last_hash
    var hash = currentHash()
    $(window).bind('hashchange', function(event) {
      last_hash = hash;
      hash = currentHash();
    });
  
    // enable back/foward to close/open modal
    $("#c-modal-nav-button").on('click', function(){ window.location.href = ensureHash("#menu"); });
    function ensureHash(newHash) {
      if (window.location.hash) {
        return window.location.href.substring(0, window.location.href.lastIndexOf(window.location.hash)) + newHash;
      }
      return window.location.hash + newHash;
    }
  
    // if back button is pressed, close the modal
    $(window).on('hashchange', function (event) {
      if (last_hash == 'menu' && hash == '') {
        modal_menu.close();
        history.replaceState('', document.title, window.location.pathname);
      } // if forward button, open the modal
      else if (window.location.hash == "#menu"){
        modal_menu.open();
      }
    });
  
    // if close button is clicked, clear the #menu hash added above
    $('#close-total-modal').on('click', function (e) {
      history.replaceState('', document.title, window.location.pathname);
    });
  
    // close modal menu if esc key is used
    $(document).keyup(function (e) {
      if( e.keyCode == 27 && hash == 'menu' ) {
        window.history.back();
      }
    });
  }
  modalExtras();


  var backBtn = $('#back-top');

  $('#back-top').on('click', function() {
    $(this).removeClass( 'show' )
  });
  $(window).scroll(function() {
    if ($(window).scrollTop() > 600) {
      backBtn.addClass('show');
    } else {
      backBtn.removeClass('show');
    }
  });


  // click to open menu navigation -------------------------
  $( '.c-main-menu .menu-item-has-children > a' ).on( 'click', function (ev) {
    if (!$(this).parent().hasClass('is-active')) {
      ev.preventDefault();
    }
    $(this).parent().toggleClass( 'is-active' );
    $(this).next('.sub-menu').toggleClass( 'is-active' );
  });

  $( '.c-main-menu .menu-item-has-children' ).on( 'click', function (ev) {
    $(this).siblings().removeClass( 'is-active' );
    $(this).siblings().children().find( '.is-active' ).removeClass( 'is-active');
  });

  // accordion for modal menu navigation -------------------------
  $( '.c-modal-menu .menu-item-has-children > a' ).on( 'click', function (ev) {
    ev.preventDefault();
    $(this).parent().toggleClass( 'is-active' );
    $(this).next('.sub-menu').toggleClass( 'is-expanded' );
  });


  // search form modal with slide down effect ------------------------
  $('#search-button').magnificPopup({
    type: 'inline',
    focus: '.search-input',
    removalDelay: 500,
    callbacks: {
      beforeOpen: function() {
         this.st.mainClass = this.st.el.attr('data-effect');
      },
      open: function() { 
        $('.c-page-header').css('overflow-y', 'scroll');
      },
      close: function() {
        $('.c-page-header').css('overflow-y', 'hidden');
      }
    },
  });

  $('#search-button2').magnificPopup({
    type: 'inline',
    focus: '.search-input',
    removalDelay: 500,
    callbacks: {
      beforeOpen: function() {
         this.st.mainClass = this.st.el.attr('data-effect');
      },
      open: function() { 
        $('.c-page-header').css('overflow-y', 'scroll');
      },
      close: function() {
        $('.c-page-header').css('overflow-y', 'hidden');
      }
    },
  });


});
// END CUSTOM JQUERY DOC READY ------------------------------
